module.exports = __webpack_public_path__ + "img/privacy.591e4f66.svg";